<script setup lang="ts">
import AccountMenu from "./AccountMenu.vue";
import MobileSidebar from "./MobileSidebar.vue";
import MenuButton from "./MenuButton.vue";
import { useContentStore } from "@/stores/contentStore";
import { Search } from "@/components/icons";
import { ref } from "vue";
import LogoSidebar from "@/components/general/LogoSidebar.vue";

const openSidebar = ref(false);

const contentStore = useContentStore();
</script>

<template>
  <div
    class="bg-background-primary border-b border-border-primary flex items-center p-4"
  >
    <MenuButton @click="openSidebar = true" />
    <RouterLink to="/" class="ml-2">
      <LogoSidebar class="w-24" />
    </RouterLink>
    <div class="ml-auto flex gap-2">
      <button @click="contentStore.showSearchModal = true" class="p-1">
        <Search />
      </button>
      <AccountMenu />
    </div>
  </div>
  <MobileSidebar v-model="openSidebar" />
</template>
